import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import Header from '@/components/Header/Header.vue';
import { useRoute } from 'vue-router';
import { useMsalAuthentication } from '@/composition-api/useMsalAuthentication';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from '@/authConfig';
import { useIsAuthenticated } from '@/composition-api/useIsAuthenticated';

// Per msal documentation this will act as a navigation guard

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useIsAuthenticated();
useMsalAuthentication(InteractionType.Redirect, loginRequest);
const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _unref(route).fullPath
    }))
  ], 64))
}
}

})